import React, { useContext } from "react";
import { IADPState } from "../types";
import { IADPActions } from "../state/Actions";

interface IStateContext {
  dispatch: React.Dispatch<IADPActions>;
  state: IADPState;
}

export const StateContext = React.createContext<IStateContext | null>(null);

export function useStateContext() {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error("State context was not able to be initialized!");
  }
  return {
    state: { ...context.state },
    dispatch: context.dispatch,
  };
}
